var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M23.9,8.2c-2.4,0.3-4.3,2.2-4.6,4.6v14.4c0.3,1.9,2.1,3.1,3.9,2.8c1.4-0.2,2.5-1.4,2.8-2.8V16.4 c0-0.3-0.2-0.5-0.5-0.5S25,16.1,25,16.4v10.8c0,1.3-1,2.3-2.3,2.3c0,0-0.1,0-0.1,0c-1.3,0.1-2.3-0.9-2.4-2.2c0,0,0-0.1,0-0.1V12.8 c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4V30c0,3.6-2.9,6.5-6.5,6.5S16,33.6,16,30V17.6c0-0.2-0.3-0.4-0.5-0.4c-0.2,0-0.5,0.2-0.5,0.4V30 c0.1,4.1,3.4,7.4,7.5,7.5c4.1-0.1,7.4-3.4,7.5-7.5V12.8C29.6,9.8,26.9,7.8,23.9,8.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paper_clip.c9407a270ac9b3099f31ba9aeebcb8b7.svg";
export { ForwardRef as ReactComponent };